import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

/** BAO-999 / BAO-1008: one required wording, always names the field. */
export function requiredMessage(field: string): string {
  return `Bitte ${field} ausfüllen.`;
}

export function invalidEmailMessage(): string {
  return 'Bitte eine gültige E-Mail-Adresse eingeben.';
}

export const UNKNOWN_BARCODE_MESSAGE = 'Dieser Barcode ist unbekannt.';

export function markTreeDirty(control: AbstractControl): void {
  control.markAsDirty();
  control.markAsTouched();
  control.updateValueAndValidity({ onlySelf: true });

  if (control instanceof FormGroup) {
    Object.values(control.controls).forEach(child => markTreeDirty(child));
    return;
  }

  if (control instanceof FormArray) {
    control.controls.forEach(child => markTreeDirty(child));
  }
}

export function markTreePristine(control: AbstractControl): void {
  control.markAsPristine();
  control.markAsUntouched();
  control.updateValueAndValidity({ onlySelf: true });

  if (control instanceof FormGroup) {
    Object.values(control.controls).forEach(child => markTreePristine(child));
    return;
  }

  if (control instanceof FormArray) {
    control.controls.forEach(child => markTreePristine(child));
  }
}

/** Scroll the first invalid control into the nearest scrollport (modal body or page). */
export function scrollFirstInvalid(root: HTMLElement | null | undefined): void {
  if (!root) {
    return;
  }

  const invalid = root.querySelector('.ant-form-item-has-error') as HTMLElement | null;
  if (!invalid) {
    return;
  }

  invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
  const focusable = invalid.querySelector(
    'input:not([type="hidden"]), textarea, select, .ant-select-selection-search-input, .ant-picker-input input'
  ) as HTMLElement | null;
  focusable?.focus();
}
